import VueAdsense from './VueAdsense.vue'
export default VueAdsense



//////////////////
// WEBPACK FOOTER
// ./~/vue-adsense/main.js
// module id = 126
// module chunks = 35